import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchDespatchParticularsFormatOfContents = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getDespatchParticularsFormatOfContents',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchDespatchParticularsFormatOfContents;
